import React from 'react';

import { flagStyles } from '../settings';

const SvgAG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-72px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAG;
